<script setup lang="ts">
import { ref } from 'vue'
import { Permission } from '../../../../types/auth'
import ListTemplate from '../../../../components/ui/common/ListTemplate.vue'
import { FilterField, TableField } from '../../../../components/table/table'
import StockCountsForm from './StockCountsForm.vue';
import AddCountForm from './AddCountForm.vue';
import MessageBox from '../../../../services/MessageBox';
import Toast from '../../../../services/Toast';
import { api } from '../../../../api/Api';

const endPoint = '/clients/inventory/inventory-management/stock-counts/'
const title = 'Stock Counts'
const selectedData = ref<any | null>(null)
const showForm = ref(false)
const formMode = ref<'create' | 'edit' | 'view' | 'showQuickView' | 'toggleStatus'>('view')
const refreshData = ref(false)

const showCountForm = ref(false)
const permissions = ref<Permission[]>();

const fields: TableField[] = [
  { name: 'date_time', caption: 'Date', sortable: true, fieldType: 'date' },
  { name: 'ref_no', caption: 'Ref. No', sortable: true, fieldType: 'text'},
  { name: 'outlet', caption: 'Outlet', sortable: true, fieldType: 'text'},
  { name: 'warehouse', caption: 'Warehouse', sortable: true, fieldType: 'text' },
  { name: 'adjustment_account', caption: 'Adjustment Account', sortable: true, fieldType: 'text' },
  { name: 'fresh_count', caption: 'Fresh Count', sortable: true, fieldType: 'checkbox' },
  { name: 'status', caption: 'Status', sortable: false, fieldType: 'text' },
]

const filterFields: FilterField[] = [
  {
    name: 'active',
    label: 'Status',
    type: 'select',
    value: '',
    options: [
      { id: '1', name: 'Active' },
      { id: '0', name: 'Inactive' }
    ],
  },
]

const changeMode = (
  mode: "create" | "edit" | "view" | "showQuickView" | "toggleStatus"
) => {
  formMode.value = mode;
  showForm.value = mode === "view" || mode === "edit" || mode === "create";
};

const handleData = (data : any) => {
  selectedData.value = data
}

const startCount = async (action: string, data: any) => {
  if (action === 'add-count') {
    selectedData.value = data
    showCountForm.value = true
  } else if (action === 'update-stock-count') {
    const confirmed = await MessageBox.confirm({
    title: "Update Stock Count",
    message: "Are you sure you want to Update the Stock Count? This action cannot be undone.",
    confirmText: "Yes, Update",
    cancelText: "No",
    type: "info",
  });
  if (confirmed) {
    handleConfirmStockCountUpdate(data);
  }
  }
}

const handleConfirmStockCountUpdate = async (data: any) => {
  const response = await api.post(endPoint + 'update-stock-count', { 
    id: data.uid,
    warehouses_id: data.warehouse_id,
    outlets_id: data.outlet_id, 
  });
  if (response.success) {
    Toast.show('Stock Count updated successfully');
    refreshData.value = !refreshData.value;
  } else {
    Toast.show('Failed to update Stock Count');
  }
}

const listViewRef = ref<InstanceType<typeof ListTemplate> | null>(null);
const viewDocument = (data : any, title: string, path: string) => {
  if (listViewRef.value) {
    listViewRef.value.viewDocument(data, title, path);
  }
}

</script>
<template>
  <ListTemplate ref="listViewRef" :endPoint = "endPoint" :title = "title" :fields = "fields" :actions = "[
    { name: 'add-count', title: 'Add Count', icon: 'Layers', permission: 'Add Stock Count', visible: (item) => item.status == 'Pending', variant: 'primary' },
    { name: 'update-stock-count', title: 'Update Stock Count', icon: 'PackageCheck', permission: 'Add Stock Count', visible: (item) => item.status == 'Pending', variant: 'warning' },
  ]" :filterFields ="filterFields" @custom="startCount"
  :tabList = "[]" :refreshData = "refreshData" @mode="changeMode" @show="showForm = true" :showForm="showForm" 
  @data="handleData">
  
  <template #form-view>
    <StockCountsForm
      v-if="showForm"
      :permissions="permissions"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      :mode="formMode"
      @view-document="viewDocument"
      @save="refreshData = !refreshData"
      @close="showForm = !showForm"
    />
  </template>
  </ListTemplate>
  <AddCountForm
      v-if="showCountForm"
      :permissions="permissions"
      :data="selectedData"
      :end-point="endPoint"
      :title="title"
      mode="create"
      @view-document="viewDocument"
      @save="refreshData = !refreshData"
      @close="showCountForm = !showCountForm"
    />
</template>